import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { Breadcrumb, MenuService } from './menu.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of, take } from 'rxjs';
import { DirectSearchAPIInput, GetTotalInput, SelectModalInputData, SelectModalItem, SelectModalOutput } from 'models';
import { FavoriteService } from 'src/_services/favorite.service';
import { MatDialog } from '@angular/material/dialog';
import { SelectModalComponent } from '../utilities/select-modal/select-modal.component';
import { environment } from 'src/environments/environment';
import { BrowserConfig, BrowserStorageService, LoginService, SurveyService } from 'src/_services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PublicEventsService, EventTypes } from 'angular-auth-oidc-client';
import { SessionStorageKeys } from 'utility';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent {
  userData$: Observable<any> = of({});
  isAuthenticated = false;

  urlHandler:string
  // domain= window["openiddictsettings"]["authority"];
  domain = BrowserConfig.openiddictsettings.authority;

  isLoading: boolean = false;

  public breadcrumbs: Breadcrumb[]=[]
  private isLogged = false;
  public getScreenWidth: any = null;
  public height?: number;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private MS: MenuService,
    private oidcSecurityService: OidcSecurityService,
    private favorites: FavoriteService,
    private dialog: MatDialog,
    private survey: SurveyService,
    private snackBar: MatSnackBar,
    private _login: LoginService,
    private router: Router,
    private eventService: PublicEventsService,
    private browserStorage: BrowserStorageService
  ) { }

  ngOnInit() {
    // this.getScreenWidth = window.innerWidth;
    // this.setHeight();
    const window = this.document.defaultView;
    this.getScreenWidth = window.innerWidth;
    this.setHeight();
    this.MS.getbreadcrumbs().subscribe(res => this.breadcrumbs=res),
    this.userData$ = this.oidcSecurityService.userData$;


    this.oidcSecurityService.isAuthenticated$.subscribe(
      ({ isAuthenticated }) => {
        this.isAuthenticated = isAuthenticated;
        this._login.isAuthenticated = this.isAuthenticated;
        console.warn('authenticated: ', isAuthenticated);
      }
    );
    

    this.eventService.registerForEvents()
      .subscribe((value) => {
        if ( [EventTypes.CheckingAuthFinished, EventTypes.CheckingAuthFinishedWithError].includes(value.type)) {
          // const redirectUrl = sessionStorage.getItem(SessionStorageKeys.redirectUrlKey);
          const redirectUrl = this.browserStorage.getData(SessionStorageKeys.redirectUrlKey, 'sessionStorage');
          if (redirectUrl) {
            // sessionStorage.removeItem(SessionStorageKeys.redirectUrlKey);
            this.browserStorage.removeData(SessionStorageKeys.redirectUrlKey, 'sessionStorage');
            this.router.navigateByUrl(redirectUrl);
          }
        }
      });
  }

  ngAfterContentChecked() {
    const window = this.document.defaultView;
    this.getScreenWidth = window.innerWidth;
    this.setHeight();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    const window = this.document.defaultView;
    this.getScreenWidth = window.innerWidth;
    this.setHeight();

  }
  public setHeight() {
    const window = this.document.defaultView;
    this.getScreenWidth = window.innerWidth;

    if (this.getScreenWidth > 1070) this.height = 45;
    else if (this.getScreenWidth > 758) this.height = 35;
    else if (this.getScreenWidth > 576) this.height = 25;
    else this.height = 20;
  }  

  goToLinkExt(url: string) {
    window.open(url, "_blank");
  }

  goToLink(url: string) {
    this.router.navigateByUrl(url);
  }

  login(): void {
      console.log('start login');
    this._login.login(this.router.url.toLocaleLowerCase().startsWith('/survey') ? this.survey.getQuestions() : null);
  }

  logoffAndRevokeTokens(): void {
      // this.oidcSecurityService.logoffAndRevokeTokens().subscribe((result) => console.log(result));
      this._login.logOff(this.router.url.toLocaleLowerCase().startsWith('/survey') ? this.survey.getQuestions() : null);
  }

  loadFavorites() {
    if (this.isAuthenticated) {
      this.isLoading = true;
      this.favorites.loadFavorites(this.viewSavesModal.bind(this, 'products'));
    }
    else { this._login.showLoginIsRequiredMsg(); }
  }

  loadSavedSurveys() {
    if (this.isAuthenticated) {
      this.isLoading = true;
      this.survey.loadSavedSurveys(this.viewSavesModal.bind(this, 'surveys'));
    }
    else { this._login.showLoginIsRequiredMsg(); }
  }

  viewSavesModal(savesOf: ('surveys' | 'products')) {
    this.isLoading = false;
    let modalTitle: string = undefined;
    let modalSubTitle: string = undefined;
    let selectItems: SelectModalItem[] | GetTotalInput[] = [];
    let emptyMsg: string = 'Nessun elemento trovato';

    switch(savesOf) {
      case 'products':
        modalTitle = 'Prodotti salvati';
        modalSubTitle = 'Clicca un prodotto per accedere al dettaglio';
        emptyMsg = 'Nessuno prodotto salvato';
        const favorites = this.favorites.getFavorites() ?? [];
        selectItems = favorites.map(x => {
          return {
            id: x.Id.toString(),
            label: x.Name,
            value: x.FidaCode,
            isSelected: false
          }
        });
      break;

      case 'surveys':
        modalTitle = 'Ricerche salvate';
        modalSubTitle = 'Clicca un salvataggio per caricarlo';
        emptyMsg = 'Nessuna ricerca salvata';
        const savedSearches = this.survey.getSavedSurveys() ?? [];
        selectItems = savedSearches.map(x => {
          return {
            id: x.Id.toString(),
            label: x.Name ?? x.Id.toString(),
            iconImg: x.SearchProduct != null ? "./assets/imgs/Ricerca-diretta-colored.png" : "./assets/imgs/Ricerca-guidata-colored.png",
            value: x.Id.toString(),
            isSelected: false
          }
        });
      break;
    }

    const modalData: SelectModalInputData = {
      header: modalTitle,
      subHeader: modalSubTitle,
      selectItems: selectItems,
      isMultipleSelection: false,
      emptyMsg: emptyMsg,
      isShowDeleteButton: true
    }

    
    
    const dialogRef = this.dialog.open(SelectModalComponent, {
      width: '400px',
      maxHeight: '600px',
      data: modalData
    });

    dialogRef.afterClosed().subscribe(
      (result: SelectModalOutput) => {
        if (result != null) {
          if (result['isDelete']) {
            const itemsToDelete: string[] = result['items']?.map(x => x.value) ?? [];
            if (itemsToDelete) {
              this.deleteSavedItems(itemsToDelete, savesOf);
            }
          }
          else {
            switch(savesOf) {
              case 'products':
                this.viewProductDetails(result[0]);
              break;

              case 'surveys':
                const savedSearches = this.survey.getSavedSurveys() ?? [];
                const saveId = (typeof result[0] === 'number') ? result[0] : parseInt(result[0]);
                const saveItem = savedSearches.find(x => x.Id == saveId);

                if (saveItem.SearchProduct != null) {
                  this.goToDirectSearch(saveItem.SearchProduct)
                }
                else {
                  this.goToGuidedSearch(saveId);
                }

              break;
            }
          }
        }
      }
    )
    
  }

  deleteSavedItems(Ids: string[], savesOf: ('surveys' | 'products')) {
    this.isLoading = true;
    if (Ids.length > 0) {
      const itemToDelete = Ids.pop();
      switch (savesOf) {
        case 'surveys':
          this.survey.deleteSavedSurveyById(itemToDelete, this.deleteSavedItems.bind(this, Ids, savesOf));
        break;
        case 'products':
          this.favorites.deleteProductFromFavorites(itemToDelete, this.deleteSavedItems.bind(this, Ids, savesOf))
        break;
      }
    }
    else {
      this.isLoading = false;
      this.snackBar.open("Le ricerche sono state cancellate", "Chiudi", { duration: 5000 });
    }
  }

  viewProductDetails(fidaCode) {
    if(fidaCode != null) {
      let baseDomain: string = BrowserConfig.baseDomain.toString();
      if(!baseDomain.endsWith('/')) { baseDomain = `${baseDomain}/` };
      // window.open(`${baseDomain}comparatore/#/policy/${fidaCode}`);
      this.router.navigateByUrl(`/policy/${fidaCode}`)

    }
  }

  goToGuidedSearch(searchId: string | number) {
    if(searchId != null) {
      let _id = (typeof searchId === 'number') ? searchId : parseInt(searchId);
      // let baseDomain: string = environment.baseDomain.toString();
      // if(!baseDomain.endsWith('/')) { baseDomain = `${baseDomain}/` };
      // console.log("load save: ", _id);

      // if (environment.production) {
      //   window.open(`${baseDomain}comparatore/#/survey/${_id}`, '_self');
      // }
      // else {
      //   window.open(`https://localhost:4200/#/survey/${_id}`, '_self');
      // }

      this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
        this.router.navigate([`/survey/${_id}`]);
      });
    }
  }

  goToDirectSearch(saveParams: DirectSearchAPIInput) {
    this.router.navigate(['/directsearch'], {
      queryParams: {
        Company: saveParams.Companies[0],
        Expire: saveParams.Expire,
        Class: saveParams.Classes[0],
        Risk: saveParams.Risks,
        Name: saveParams.Name
      }
    });
  }

}
